import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  paragraph: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
    lineHeight: 1.8
  },
  separator: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(5, 0)
  },
  field: {
    width: '100%',
    marginBottom: theme.spacing(3),
    paddingInline: theme.spacing(1)
  },
  fieldGroup: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(2),

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  label: {
    display: 'block',
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    color: '#2c3e51',
    fontSize: '0.95rem'
  },
  input: {
    width: '100%',
    height: 52,
    padding: '12px',
    border: '1px solid #2e2972',
    borderRadius: 13,
    fontSize: '1rem',
    color: '#2c3e51',
    '&:focus': {
      outline: 'none'
    }
  },
  inputDate: {
    width: '100%',
    height: 42,
    padding: '0 12px',
    border: '1px solid #2e2972',
    borderRadius: 4,
    backgroundColor: '#fff',
    color: '#2c3e51',
    '&:focus': {
      outline: 'none'
    }
  },
  errorWrapper: {
    textAlign: 'center',
    background: '#ff9b9b',
    color: '#3c0000',
    borderRadius: 8,
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2)
  }
}))
